<template>
  <section :class="`homepage-banner vb23-hero ${loading ? 'loading' : ''}`" aria-labelledby="vb23-hero-title">
    <div class="loader">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
      <div class="bar4"></div>
      <div class="bar5"></div>
      <div class="bar6"></div>
    </div>

    <div class="vb23-backdrop" aria-hidden="true">
      <div class="vb23-backdrop__grooves"></div>
      <div class="vb23-backdrop__grain"></div>
    </div>

    <div class="vb23-container vb23-hero__inner">
      <p class="vb23-hero__eyebrow"><span class="vb23-dot"></span> Royalty-free creator music library</p>
      <h1 class="vb23-hero__title" id="vb23-hero-title">
        Get <em>free music for commercial use</em>, YouTube and podcasts.
      </h1>
      <p class="vb23-hero__sub">
        Browse music for videos, podcasts, livestreams, games, ads and social content.
      </p>
      <form class="vb23-hero__search" role="search" @submit.prevent="heroSearch">
        <label class="sr-only" for="vb23-hero-search-input">Search music</label>
        <search-icon size="1.2x" class="vb23-hero__search-icon"></search-icon>
        <input id="vb23-hero-search-input" v-model="heroKeyword" type="search" placeholder="Try &quot;cinematic&quot;, &quot;lofi&quot;, &quot;wedding&quot;..." autocomplete="off" />
        <button type="submit" class="vb23-btn vb23-btn--primary">Find music</button>
      </form>
      <ul class="vb23-trust" aria-label="Why Viberary">
        <li>Free music</li>
        <li>Creator-ready tracks</li>
        <li>No sign up required</li>
      </ul>
    </div>

    <nav class="vb23-container vb23-categories" aria-label="Browse by vibe">
      <div class="vb23-section-head">
        <h2>Browse by vibe</h2>
        <span>Music and sound effects</span>
      </div>
      <div class="vb23-cat-grid">
        <router-link to="/genre/lofi" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="cafe-outline"></ion-icon></span><span class="vb23-cat__name">Lofi Chill</span></router-link>
        <router-link to="/genre/livestream" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="radio-outline"></ion-icon></span><span class="vb23-cat__name">Livestream</span></router-link>
        <router-link to="/genre/cinematic-epic" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="film-outline"></ion-icon></span><span class="vb23-cat__name">Cinematic</span></router-link>
        <router-link to="/mood/corporate" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="briefcase-outline"></ion-icon></span><span class="vb23-cat__name">Corporate</span></router-link>
        <router-link to="/genre/k-drama-ost" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="heart-outline"></ion-icon></span><span class="vb23-cat__name">K-Drama OST</span></router-link>
        <router-link to="/mood/happy" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="sunny-outline"></ion-icon></span><span class="vb23-cat__name">Happy</span></router-link>
        <router-link to="/mood/vlog-travel" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="map-outline"></ion-icon></span><span class="vb23-cat__name">Vlog / Travel</span></router-link>
        <router-link to="/soundeffects" class="vb23-cat"><span class="vb23-cat__emoji" aria-hidden="true"><ion-icon name="sparkles-outline"></ion-icon></span><span class="vb23-cat__name">Sound Effects</span></router-link>
      </div>
    </nav>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import { SearchIcon } from 'vue-feather-icons';

export default {
  components: {
    SearchIcon,
  },
  data() {
    return {
      heroKeyword: '',
    };
  },
  methods: {
    async heroSearch() {
      const keyword = (this.heroKeyword || '').trim();
      if (!keyword) {
        return;
      }
      if (window.viberaryTrackEvent) {
        window.viberaryTrackEvent('search_submit', {
          list_context: 'hero',
          device_class: window.innerWidth < 768 ? 'mobile' : 'desktop'
        });
      }
      await this.$router.push({ path: '/search/' + keyword }).catch(() => {});
    },
  },
  computed : {
    ...mapGetters({
      loading : 'player/getIsLoading',
    }),
  }
};
</script>
